// extracted by mini-css-extract-plugin
module.exports = {"headline":"style-module__headline___EA0Rk","text":"style-module__text___ELi83"};